module.exports = __webpack_public_path__ + "img/KBANK.ab82184d.jpeg";